import { render, staticRenderFns } from "./SupporterViewUpdateDetails.vue?vue&type=template&id=88844026&"
import script from "./SupporterViewUpdateDetails.vue?vue&type=script&lang=js&"
export * from "./SupporterViewUpdateDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports